<script>
  import { onMount } from "svelte";

  let loadingFailed = false;

  // Load login module from AdminApp remote
  async function mountLogin() {
    try {
      const m = await import("AdminApp/GrappleAuth/login");
      const Login = m.default;

      new Login({
        target: document.getElementById("login"),
        layout: "auto"
      });
    } catch (err) {
      console.error("FAILED to load GrappleAuth login:", err);
      loadingFailed = true;
    }
  }

  onMount(() => {
    mountLogin();

    // Add redirect parameter
    const url = new URL(window.location.href);
    if (!url.searchParams.has("redirectUrl")) {
      url.searchParams.set("redirectUrl", "/admin");
      window.history.replaceState({}, "", url.toString());
    }
  });
</script>

{#if !loadingFailed}
  <div id="login"></div>
{:else}
  <div style="padding:40px; text-align:center;">
    <h2>Authentication service unavailable</h2>
    <p>Please refresh the page or contact support.</p>
  </div>
{/if}